import gql from 'graphql-tag';

const UPDATE_CHANGEOVER = gql`
  mutation UpdateChangeover(
    $id: ID!
    $mo: String!
    $production: String!
    $partsByCycle: Int
    $operationsByCycle: Int
    $commandLaunches: String
    $activateCounting: Boolean
    $phase: String
    $countType: String
  ) {
    updateChangeover (
      input: {
        id: $id
        mo: $mo
        production: $production
        partsByCycle: $partsByCycle
        operationsByCycle: $operationsByCycle
        commandLaunches: $commandLaunches
        activateCounting: $activateCounting
        phase: $phase
        countType: $countType
      }
    ) {
      id
      mo
      production
      updatedBy
      partsByCycle
      operationsByCycle
      commandLaunches
      activateCounting
      isLast
      clTrigger
      phase
      countType
    }
  }
`;

export const DISABLE_CHANGEOVER_COUNTING = gql`
  mutation DisableChangeoverCounting($id: ID!) {
    disableChangeoverCounting(id: $id) {
      id
      activateCounting
      clTrigger
      countType
    }
  }
`;

export const UPDATE_FULL_CHANGEOVER = gql`
  mutation UpdateFullChangeover($input: UpdateFullChangeoverInput!) {
    updateFullChangeover(input: $input) {
      id
      clTrigger
    }
  }
`;

export default UPDATE_CHANGEOVER;
